import type * as React from 'react';
import { get } from '@Domain/Api';
import organizationWorkflowsFetched, {
	type OrganizationWorkflowPayload,
	type OrganizationWorkflowsFetchedAction,
} from '@Application/Organizations/Workflows/Actions/organizationWorkflowsFetched';
import organizationWorkflowsFetchFailed, {
	type OrganizationWorkflowsFetchFailedAction,
} from '@Application/Organizations/Workflows/Actions/organizationWorkflowsFetchFailed';
import type FetchOrganizationWorkflows from '@Application/Organizations/Workflows/Queries/FetchOrganizationWorkflows';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = OrganizationWorkflowsFetchedAction | OrganizationWorkflowsFetchFailedAction;

export default (query: FetchOrganizationWorkflows) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const response = await get<OrganizationWorkflowPayload[]>(
				`${parameters.api.host}/api/organizations/${query.organizationId}/workflows`,
			);

			const action = organizationWorkflowsFetched(response, query.organizationId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = organizationWorkflowsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
